import React from "react";
// Assuming you have imported your icons like this:

import FeaturesCards from "./FeaturesCards";

const HexagonCards = () => {
  return (
    <div className="section-hexagon-cards py-5">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h1 className="section-title pt-5 text-center">
              Why is Share-Circle different?
            </h1>
          </div>
        </div>
      <FeaturesCards/>

          {/* */}
       

          {/* */}
        

          {/* */}
        
        </div>
      </div>
  
  );
};

export default HexagonCards;